import * as React from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CustomSetting, Setting } from 'types/types';

const useStyles = makeStyles((theme) => ({
  fieldContainer: {
    display: 'flex',
    flex: 1,
    marginTop: theme.spacing(1),
    flexDirection: 'row'
  },
  inputText: { fontSize: 13 },
  textField: {
    flex: 1,
    whiteSpace: 'pre-line',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(1)
  },
  keyField: { marginRight: theme.spacing(1.25) },
  valueField: { marginLeft: theme.spacing(1.25) }
}));

type CustomFieldSectionProps = {
  index: number;
  isInvalidField: { key: boolean; value: boolean };
  changedFields: any;
  setChangedFields: React.Dispatch<React.SetStateAction<any>>;
  initialSelectValue: Setting;
  setSettings: React.Dispatch<React.SetStateAction<any>>;
  inputSetting: CustomSetting;
};

export const CustomFieldSection: React.FC<CustomFieldSectionProps> = ({
  index,
  isInvalidField,
  changedFields,
  setChangedFields,
  initialSelectValue,
  setSettings,
  inputSetting
}: CustomFieldSectionProps) => {
  const classes = useStyles();

  const settingId = inputSetting?.id;
  const isFieldChanged = settingId && changedFields[settingId][index];

  const [customField, setCustomField] = React.useState(initialSelectValue);

  React.useEffect(() => {
    setCustomField(initialSelectValue);
  }, [initialSelectValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (settingId) {
      const updated = { ...changedFields };
      const updatedFields = [...updated[settingId]];
      updatedFields[index] = { ...updatedFields[index], [name]: true };
      updated[settingId] = updatedFields;
      setChangedFields(updated);
    }

    setCustomField((prev) => ({
      ...prev,
      [name]: value
    }));

    setSettings((prev: any) => {
      const newSettings = [...prev];
      newSettings[index][name] = value;
      return newSettings;
    });
  };

  return (
    <div className={classes.fieldContainer}>
      <TextField
        size="small"
        name="key"
        value={customField.key}
        onChange={handleInputChange}
        placeholder={inputSetting?.placeholder?.key}
        error={
          isFieldChanged.key
            ? customField.key.trim() === ''
            : isInvalidField.key
        }
        className={`${classes.textField} ${classes.keyField}`}
        InputProps={{
          classes: { input: classes.inputText }
        }}
      />
      <TextField
        size="small"
        name="value"
        value={customField.value}
        onChange={handleInputChange}
        placeholder={inputSetting?.placeholder?.value}
        error={
          isFieldChanged.value
            ? customField.value.trim() === ''
            : isInvalidField.value
        }
        className={`${classes.textField} ${classes.valueField}`}
        InputProps={{
          classes: { input: classes.inputText }
        }}
      />
    </div>
  );
};
